// Tento súbor je generovaný automaticky – nemeňte ho ručne.
// Aktualizuje sa pri každom 'npm start' aj 'npm run build'.

export const BUILD_INFO = {
  version: '0.2026.1',
  timestamp: '2026-05-31T14:28:40.217Z',
  buildDate: '31. 5. 2026',
  buildTime: '16:28:40'
};